(function () {
    angular.module("cardspotWeb.areas.hvtFulfillment")
        .controller("HvtCancelConfirmModal", HvtCancelConfirmModal);

    HvtCancelConfirmModal.$inject = ["$scope", "$uibModalInstance"];

    function HvtCancelConfirmModal($scope, $uibModalInstance) {
        var model = this;
        $scope.yes = yes;
        $scope.no = no;
        model.note = undefined;

        function yes(note) {
            $uibModalInstance.close({
                isConfirmed: true,
                note: note
            });
        }

        function no() {
            $uibModalInstance.close({
                isConfirmed: false
            });
        }
    }
}());